import Vue from 'vue';

export const notifySend = (title = '', message, type = 'info', options = {}) => Vue.swal({
    text: message,
    icon: type,
    title,
    buttonsStyling: false,
    confirmButtonClass: 'btn btn-primary',
    cancelButtonClass: 'btn btn-light',
    reverseButtons: true,
    confirmButtonText: 'OK',
    cancelButtonText: 'Avbryt',
    onClose: options.onClose ? options.onClose : null,
    onOpen: options.onOpen ? options.onOpen : null,
});

export default notifySend;
